import React from 'react';
import { Tag, Button, Dropdown, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
  faEdit,
  faTrash,
  faHeart,
  faCalendarDays,
  faClock,
  faEye,
  faEyeSlash,
  faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';

export const getEventTypeColumns = (handleEdit, handleDelete) => {
  const getMenuItems = (eventType) => [
    {
      key: 'edit',
      label: 'Edit',
      icon: <FontAwesomeIcon icon={faEdit} />,
      onClick: () => handleEdit(eventType)
    },
    {
      key: 'delete',
      label: 'Delete',
      icon: <FontAwesomeIcon icon={faTrash} />,
      onClick: () => handleDelete(eventType)
    }
  ];

  return [
    {
      title: 'Event Type',
      key: 'eventType',
      width: 250,
      render: (_, record) => (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '32px',
                height: '32px',
                minWidth: '32px',
                minHeight: '32px',
                borderRadius: '50%',
                backgroundColor: record.color || '#1890ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <FontAwesomeIcon icon={faHeart} style={{ color: 'white', fontSize: '14px' }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 'bold', fontSize: '16px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {record.name}
              </div>
              <div style={{ color: '#666', fontSize: '14px', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {record.description || 'No description provided'}
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      width: 100,
      render: (duration) => {
        const displayDuration = duration < 1 
          ? `${Math.round(duration * 60)} min`
          : `${duration} ${duration === 1 ? 'hour' : 'hours'}`;
        return (
          <div>
            <FontAwesomeIcon icon={faClock} style={{ marginRight: '6px', color: '#666' }} />
            <span>{displayDuration}</span>
          </div>
        );
      }
    },
    {
      title: 'Advance Booking',
      dataIndex: 'advanceBookingDays',
      key: 'advanceBookingDays',
      width: 140,
      render: (days) => (
        <div>
          <FontAwesomeIcon icon={faCalendarDays} style={{ marginRight: '6px', color: '#666' }} />
          <span>{days === 0 ? 'Unlimited' : `${days || 30} days`}</span>
        </div>
      )
    },
    {
      title: 'Total Bookings',
      key: 'bookingCount',
      width: 120,
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#1890ff' }}>
            {record.bookingCount || 0}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            bookings
          </div>
        </div>
      )
    },
    {
      title: 'Location',
      key: 'location',
      width: 120,
      render: (_, record) => (
        record.city ? (
          <div>
            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: '6px', color: '#22c55e' }} />
            <span>{record.city}{record.state ? `, ${record.state}` : ''}</span>
          </div>
        ) : (
          <span style={{ color: '#999' }}>Not set</span>
        )
      )
    },
    {
      title: 'Public',
      key: 'publiclyVisible',
      width: 80,
      render: (_, record) => (
        <Tooltip title={record.publiclyVisible !== false ? 'Visible on public booking page' : 'Hidden from public booking page'}>
          <Tag color={record.publiclyVisible !== false ? 'blue' : 'default'}>
            <FontAwesomeIcon 
              icon={record.publiclyVisible !== false ? faEye : faEyeSlash} 
              style={{ marginRight: '4px' }} 
            />
            {record.publiclyVisible !== false ? 'Yes' : 'No'}
          </Tag>
        </Tooltip>
      )
    },
    {
      title: 'Status',
      key: 'status',
      width: 100,
      render: (_, record) => (
        <Tag color={record.isActive ? 'green' : 'default'}>
          {record.isActive ? 'Active' : 'Inactive'}
        </Tag>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 80,
      render: (_, record) => (
        <Dropdown
          menu={{ items: getMenuItems(record) }}
          trigger={['click']}
        >
          <Button type="text" icon={<FontAwesomeIcon icon={faEllipsisV} />} />
        </Dropdown>
      )
    }
  ];
};
